import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';
import { NavItem } from 'reactstrap';
import PropTypes from 'prop-types';

import globalTranslations from '../../../i18n/globalTranslations';
import Icon from '../../common/Icon';
import HeaderNavAction from '../HeaderNavAction';

@observer
export class TopNavigationSearchButton extends Component {
  render() {
    return (
      <NavItem className="TopNavigationSearchButton">
        <HeaderNavAction
          surface="top"
          onClick={this.props.onShowSearchOnTopNavigation}
        >
          <Icon name="search" />
          <FormattedMessage {...globalTranslations.search} />
          <Icon name="angle-down" />
        </HeaderNavAction>
      </NavItem>
    );
  }
}

TopNavigationSearchButton.propTypes = {
  onShowSearchOnTopNavigation: PropTypes.func.isRequired,
};

export default TopNavigationSearchButton;
